import { createSlice } from '@reduxjs/toolkit';

const initialState = {};

const commonDataSlice = createSlice({
  name: 'commonData',
  initialState,
  reducers: {
    setCommonDataModelData: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    setCommonDataIsLoading(state, action) {
      state.isloading = action?.payload?.isloading;
    },
    setCodeEditorToggle(state, action) {
      state.codeEditorToggle = action?.payload?.codeEditorToggle
    },
    setCurrentCustomScript(state, action) {
      state.currentCustomScript = action?.payload
    },
    setCurrentCustomCss(state, action) {
      state.currentCustomCss = action?.payload
    },
    setCodeEditorRndStyle(state, action) {
      state.codeEditorRndStyle = {
        ...state.codeEditorRndStyle,
        ...action?.payload
      }
    },
    setCssCodeEditorToggle(state, action) {
      state.cssCodeEditorToggle = action?.payload?.cssCodeEditorToggle
    },
    setAddCustomStyle(state, action) {
      state.addCustomStyle = action?.payload?.addCustomStyle
    },
    resetCommonData:()=>initialState,
  },
});

const { reducer, actions } = commonDataSlice;

export const { setCommonDataModelData, resetCommonData, setCodeEditorToggle, setCodeEditorRndStyle,setCurrentCustomScript, setCssCodeEditorToggle, setAddCustomStyle, setCurrentCustomCss} = actions;
export default reducer;
